import { not } from "fp-ts/Predicate";
import { and } from "./../ricos-content";
import { extract } from "./../ricos-content/lib/extract";
import { modify } from "./../ricos-content/lib/modify";
import { Node_Type } from "./../ricos-schema/legacy/wix/rich_content/v1";
import { ANCHORABLE_PLUGIN_NODES, ANCHORABLE_TEXT_NODES } from "./constants";
const isAnchorableAtomicPluginNode = (node) => ANCHORABLE_PLUGIN_NODES.includes(node.type);
const isAnchorableTextNode = (node) => ANCHORABLE_TEXT_NODES.includes(node.type);
const isAnchorableNode = (node) => {
  return isAnchorableAtomicPluginNode(node) || isAnchorableTextNode(node);
};
const isEmptyImageNode = ({ imageData, type }) => type === Node_Type.IMAGE && !(imageData?.image?.src?.id || imageData?.image?.src?.url);
const isEmptyTextNode = (node) => isAnchorableTextNode(node) && (node.nodes?.length === 0 || node.type === Node_Type.BLOCKQUOTE && node.nodes?.[0].nodes?.length === 0);
const isSelectedNode = (selectedNodeId) => (node) => {
  const { id } = node;
  return selectedNodeId === id;
};
const handleBlockquoteTextData = (nodes) => {
  return modify({ nodes }).filter((node) => node.type === Node_Type.BLOCKQUOTE).set((node) => {
    const nodes2 = node.nodes;
    if (!nodes2?.length) {
      return node;
    }
    nodes2[0].textData = nodes2[0]?.nodes?.[0]?.textData;
    return {
      ...node,
      nodes: nodes2
    };
  }).nodes;
};
const getAnchorableNodesQuery = (contentExtractor, selectedNodeId) => {
  const anchorableNodes = contentExtractor.filter(
    and([
      // @ts-ignore $TSFixMe
      isAnchorableNode,
      // @ts-ignore $TSFixMe
      not(isEmptyImageNode),
      // @ts-ignore $TSFixMe
      not(isEmptyTextNode),
      // @ts-ignore $TSFixMe
      not(isSelectedNode(selectedNodeId))
    ])
  ).get();
  const paragraphIdsToCleanup = extract(anchorableNodes).filter((node) => anchorableNodes.some((n) => node.id === n.nodes?.[0]?.id)).map((node) => node.id).get();
  const anchorableNodesWithoutDuplications = anchorableNodes.filter(
    (node) => !(paragraphIdsToCleanup.includes(node.id) && node.type === Node_Type.PARAGRAPH)
  );
  const finalAnchorableNodes = handleBlockquoteTextData(anchorableNodesWithoutDuplications);
  return finalAnchorableNodes ?? [];
};
export {
  getAnchorableNodesQuery
};
//# sourceMappingURL=getAnchorableNodesQuery.js.map
